import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useDispatch, useSelector } from "react-redux";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AddressIcon } from "../../../../Icons/AddressIcon";
import { OptionsIcon } from "../../../../Icons/optionsIcon";
import ApplicantOtherActions from "./ApplicantOtherActions";
import { ApplicantEdit } from "../../../../Icons/ApplicantEdit";
import {
  formatDate,
  GetTimeZone,
  getWorkonDate,
} from "../../../../_utilities/GetTimeZone";
import { GetUserId, GetUserInfo } from "../../../../_utilities/getUserInfo";
import { ApplicantsIcon } from "../../../../Icons/ApplicantsIcon";
import { integrationsMapping } from "../../../../ringcentralConfig";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { ApplicantSmsIcon } from "../../../../Icons/ApplicantSmsIcon";
import { decrypt } from "../../../../_utilities/_encryptDecryptHelper";
import { updateJobCode } from "../../../../_redux/SeletedJobCodeSlice";
import { ApplicantMailIcon } from "../../../../Icons/ApplicantMailIcon";
import { ApplicantCallIcon } from "../../../../Icons/ApplicantCallIcon";
import { ApplicantCrossIcon } from "../../../../Icons/ApplicantCrossIcon";
import { CallConnectedOBJ, CallOBJ } from "../../../../_utilities/constants";
import {
  resetSelectedApplicant,
  setSelectedApplicant,
} from "../../../../_redux/SelectedApplicantSlice";
import { defaultApplicantsData } from "../../../../_utilities/defaultfieldsModel";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import ApplicantDetailsNotes from "../ApplicantDetailsNotes/ApplicantDetailsNotes";
import { getCandidateInternalStatus } from "../../../../_utilities/internalexternalhelper";
import ApplicantsDetailsOverview from "../ApplicantsDetailsOverview/AppliantsDetailsOverview";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Box,
  Typography,
  IconButton,
  Tab,
  Divider,
  Tooltip,
  Fade,
  Grid,
} from "@mui/material";
import ApplicantDetailsDocuments from "../ApplicantDetailsDocuments/ApplicantDetailsDocuments";
import ApplicantDetailsAuditlogging from "../ApplicantDetailsAuditlogging/ApplicantDetailsAuditlogging";
import ApplicantDetailsAssociatedJobs from "../ApplicantDetailsAssociatedJobs/ApplicantDetailsAssociatedJobs";
import { setBreadCrumb } from "../../../../_utilities/breadCrumb";
import ApplicantDetailsEdit from "../ApplicantDetailsEdit/ApplicantDetailsEdit";
import {
  formatCurrentWorkExp,
  safeJsonParse,
} from "../../../../_utilities/utilities";
import { scrollToElement } from "../../../../_utilities/scrollHelper";
import FloatingMenu from "../../../../components/FloatingMenu/FloatingMenu";
import { ApplicantsDetailsTabsfloatingMenuOptions } from "../../../../constants/floatingMenuConstants";
import { hasAnyPhoneNumber } from "../../../../_utilities/whatsappContext";
import EmailDeliverySummary from "../../../../components/EmailDeliverySummary";
// import { EmailIcon } from '../../../../Icons/EmailIcon';

const initalState = { data: null, message: "", isloader: true };

const ApplicantsDetailsTabs = ({ onResetTabs, showAppliantDetailsById = null, onReceiveProps }) => {
  const [tab, setTab] = useState("overview");
  const [previewType, setPreviewType] = useState("");
  const [contactMenuOptions, setContactMenuOptions] = useState([]);
  const [tabvalue, setTabValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [isContactApplicant, setIsContactApplicant] = useState(false);
  const [document, setDocuments] = useState([]);
  const [primaryDocument, setPrimaryDocument] = useState([]);
  const [actionType, setActionType] = useState("");
  const [fileExtention, setFileExtention] = useState("");
  const [DocName, setDocName] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [layoutObj, setLayoutObj] = useState(CallOBJ);
  const [accociatedJobSeekerList, setAccociatedJobSeekerList] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [savedApplicant, setSavedApplicant] = useState(null);
  const [auditlogData, setAuditlogData] = useState([]);
  const [applicantsDetails, setApplicantsDetails] = useState(null);
  const [overrideApplicantsDetails, setOverrideApplicantsDetails] =
    useState(null);
  const [showEditApplicantDetails, setShowEditApplicantDetails] =
    useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const navigate = useNavigate();
  const { search } = useLocation();
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  const dispatch = useDispatch();

  const GetDocumentsdata = useSelector((state) => state.GetDocuments.data);
  const applicantIdRedux = useSelector((state) => state.SeletedJobCode.value);
  const { storedApplicant, aditionalState } = useSelector(
    (state) => state.SelectedApplicant,
  );

  const getLinkedInPath = (linkedIn) => {
    if (linkedIn) {
      return linkedIn.includes("https") ? linkedIn : `https://${linkedIn}`;
    }
  };

  useEffect(() => {
    if (Boolean(onResetTabs)) {
      setTab("overview");
    }
  }, [onResetTabs]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const page = params.get("tab");
    if (page) {
      setTab(page);
    }
  }, [search]);

  useEffect(() => {
    if (storedApplicant !== null && aditionalState === null || showAppliantDetailsById !== null) {
      setShowEditApplicantDetails(false);
      setDocuments([]);
      setPrimaryDocument([]);
      setAccociatedJobSeekerList([]);
      setAuditlogData([]);
      setNotesData([]);
      setSavedApplicant(storedApplicant ?? { id: showAppliantDetailsById });
      GetData(storedApplicant?.id ?? showAppliantDetailsById);
      dispatch(updateJobCode(storedApplicant?.id ?? showAppliantDetailsById));
    } else if (storedApplicant !== null && aditionalState !== null) {
      setShowEditApplicantDetails(true);
      setDocuments([]);
      setPrimaryDocument([]);
      setAccociatedJobSeekerList([]);
      setAuditlogData([]);
      setNotesData([]);
      setOverrideApplicantsDetails(aditionalState);
      setSavedApplicant(aditionalState?.applicant);
      GetData(aditionalState?.applicant?.id);
      dispatch(updateJobCode(aditionalState?.applicant?.id));
    }
  }, [storedApplicant, aditionalState]);

  useEffect(() => {
    if (applicantIdRedux) {
      console.log(applicantIdRedux, applicantIdRedux);
    }
  }, [applicantIdRedux]);

  useEffect(() => {
    if (GetDocumentsdata !== null && savedApplicant !== null) {
      let docData = JSON.parse(JSON.stringify(GetDocumentsdata));
      if (docData.length > 0) {
        const filterRecord = docData?.map((list) => ({
          ...list,
          docType: list.documentType,
          name: list.name?.replaceAll("-", " "),
          documentName: list.name?.replaceAll("-", " "),
          createdDate: GetTimeZone(list.createdDate),
          total_count: docData.length,
          uploadedBy: `${list.firstName || ""} ${list.lastName || ""}`.trim(),
        }));
        setDocuments(filterRecord);
        const filterPrimaryRecord = filterRecord?.filter(
          (list) => list.primaryResume === 1,
        );
        if (filterPrimaryRecord.length > 0 && tab === "overview") {
          setPrimaryDocument(filterPrimaryRecord);
          DownloadFileFromS3(
            savedApplicant?.id,
            filterPrimaryRecord[0],
            "preview",
          );
          dispatch(_ser.getDocumentsStartReducer(initalState));
        }
      } else {
        setDocuments([]);
        setPrimaryDocument([]);
        setSelectedDoc(null);
        setActionType("");
        setDocName("");
        setFileExtention("");
        setPreviewType("");
      }
    }
  }, [GetDocumentsdata]);

  const docData = useSelector((state) => state.Downloaddocument.data);
  const ApplicantData = useSelector((state) => state.ApplicantsById.data);

  const DownloadFileFromS3 = async (JobId, object, type) => {
    const actiontypeToApi =
      type === "Download" || type === "download" ? "download" : "preview";
    const actiontype =
      type === "Download" || type === "download"
        ? "download"
        : type === "view"
          ? "preview"
          : type;
    setSelectedDoc(object);
    setActionType(actiontype);
    setDocName(object.path);
    setFileExtention(object.fileType);
    dispatch(_ser.downloaddocumentAsync(JobId, actiontypeToApi, object.id));
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        setPreviewType(docData);
      } finally {
        dispatch(_ser.downloaddocumentStartReducer(initalState));
      }
    };
    run();
  }, [docData]);

  useEffect(() => {
    async function init() {
      const userDetails = await GetUserInfo();
      const selectCountry = JSON.parse(decrypt("selectCountry"));
      const integrations = userDetails?.[0]?.integrations
        ? JSON.parse(userDetails[0].integrations)
        : [];
      // const availableMenus = [
      //   {
      //     id: 0,
      //     label: "Edit Profile",
      //     icon: <ApplicantEdit />,
      //     onClick: () =>
      //       // navigate(`/ats/layout/applicants/edit/${savedApplicant?.id}`),
      //       onNavigateHandler("edit"),
      //   },
      //   {
      //     id: 1,
      //     label: "Email Candidate",
      //     icon: <ApplicantMailIcon />,
      //     onClick: () => {
      //       onNavigateHandler("Send E-mail");
      //     },
      //   },
      // ];
      const availableMenus = [
        ...ApplicantsDetailsTabsfloatingMenuOptions.inline,
      ];
      // Add Call and Send SMS option dynamically based on integrations
      integrations.forEach((integration) => {
        const integrationConfig = integrationsMapping[integration.attribute_5];
        // Check if attribute_4 contains the selected country or is empty (case insensitive)
        const countriesArray = integration.attribute_4
          ? integration.attribute_4
            .split(",")
            .map((country) => country.trim().toLowerCase())
          : [];
        const selectedCountryLower = selectCountry.name.toLowerCase();
        const shouldAddMenu =
          countriesArray.length === 0 ||
          countriesArray.includes(selectedCountryLower);
        if (
          integrationConfig &&
          integration[integrationConfig.active] === "Yes" &&
          shouldAddMenu
        ) {
          if (integration[integrationConfig.features]?.includes("Calls")) {
            availableMenus.unshift({
              // id: 2,
              label: "Make a Call",
              action: "Call",
              icon: "ApplicantCallIcon", // <ApplicantCallIcon />
              // onClick: () => onNavigateHandler("Call"),
            });
          }
          if (integration[integrationConfig.features]?.includes("Messages")) {
            availableMenus.unshift({
              // id: 3,
              label: "Send an SMS",
              action: "Send SMS",
              icon: "SendSMS", // <ApplicantSmsIcon />
              // onClick: () => onNavigateHandler("Send SMS"),
            });
          }
        }
        // WhatsApp: surface icon whenever the customer has an active
        // Whatsapp integration. Phone-number gating is applied at render
        // time so it can re-evaluate once applicant data has loaded.
        if (
          integration.attribute_5 === "Whatsapp" &&
          integration.active === "Yes"
        ) {
          availableMenus.unshift({
            label: "WhatsApp",
            action: "WhatsApp",
            icon: "ApplicantWhatsAppIcon",
          });
        }
      });
      setContactMenuOptions(availableMenus);
    }
    if (savedApplicant) {
      init();
    }
  }, [savedApplicant]);

  const onNavigateHandler = (type) => {
    if (type === "edit") {
      setShowEditApplicantDetails(true);
    } else {
      setShowEditApplicantDetails(false);
      setIsContactApplicant(true);
      setTabValue(type);
      setSelectedOption(type);
    }
  };

  const onReceivePropsHandler = (pannel, load) => {
    if (load === "close" || load === "sms") {
      setIsContactApplicant(pannel);
      setTabValue("");
    } else if (load) {
      setTabValue(load);
    } else if (load === "isImageFalse") {
      setLayoutObj(CallConnectedOBJ);
    }
  };

  const GetData = async (id) => {
    try {
      const userId = await GetUserId();
      const payLoad = { type: "Applicants", typeId: id };
      await Promise.all([
        dispatch(customFieldsAsync(userId)),
        dispatch(_ser.applicantsByIdAsync(id)),
        dispatch(_ser.getApplicantJobsAsync(id)),
        dispatch(_ser.listNotesAsync(id)),
        dispatch(_ser.getDocumentsAsync(id)),
        dispatch(_ser.getApplicantsCommentsAsync(payLoad)),
      ]);
    } catch (error) {
      console.error("GetData Error:", error);
    }
  };

  const onRenderComponentHandler = (type, state) => {
    onReceiveProps("changeAppliant");
    if (type === "loadApplicant") {
      onReceiveProps("reload");
      setShowEditApplicantDetails(false);
      setOverrideApplicantsDetails(null);
      if(state === "resetTabs") {
        setTab("overview");
      }
      dispatch(
        setSelectedApplicant({
          applicantDetails: { id: savedApplicant?.id },
          aditionalState: null,
        }),
      );
      dispatch(_ser.applicantsByIdAsync(savedApplicant?.id));
      dispatch(_ser.getDocumentsAsync(savedApplicant?.id));
    } else if (type === "notes") {
      dispatch(_ser.listNotesAsync(savedApplicant?.id));
    } else if (type === "documents") {
      dispatch(_ser.getDocumentsAsync(savedApplicant?.id));
    } else if (
      type === "associatedJobs" ||
      (type === "changeAppliant" && state === "associatejob")
    ) {
      dispatch(_ser.applicantsByIdAsync(savedApplicant?.id));
      dispatch(_ser.getApplicantJobsAsync(savedApplicant?.id));
    } else if (type === "changeAppliant" && state === "overview") {
      dispatch(_ser.getDocumentsAsync(savedApplicant?.id));
    } else if (type === "clear") {
      onCloseHandler();
    } else if (type === "edit") {
      setOverrideApplicantsDetails(state);
      setTimeout(() => {
        setShowEditApplicantDetails(true);
      }, 500);
    }
    let payLoad = { type: "Applicants", typeId: savedApplicant?.id };
    dispatch(_ser.getApplicantsCommentsAsync(payLoad));
    // dispatch(_ser.getApplicantJobsAsync(savedApplicant?.id));
  };

  const GetApplicantJobsData = useSelector(
    (state) => state.GetApplicantJobs.data,
  );
  const notesResponse = useSelector((state) => state.ListNotes.data);
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const AuditlogResponse = useSelector(
    (state) => state.GetApplicantsComments.data,
  );

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Candidate status") {
          setCandidateStatusValues(list.customValues);
        }
      });
    }
    scrollToElement("applicant-new");
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customStatusFieldsData = data.filter(
        (x) =>
          x.moduleId.toString() === "2" &&
          x.fieldType === "default" &&
          x.fieldName === "Candidate status",
      );
      if (customStatusFieldsData.length > 0) {
        let index = customStatusFieldsData.length - 1;
        let array = JSON.parse(customStatusFieldsData[index].customValues);
        setCandidateStatusValues(array);
      }
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (GetApplicantJobsData?.length && candidateStatusValues.length) {
      let myData = JSON.parse(JSON.stringify(GetApplicantJobsData));
      let newArray = [];
      myData.forEach((e, i) => {
        e["percentage"] =
          e.matchPercentage !== -1
            ? Math.round(e.matchPercentage * 100)
            : "N/A";
        e["lastUpdated"] = GetTimeZone(e.lastUpdated);
        e["isChecked"] = false;
        if (candidateStatusValues.length) {
          e.status = getCandidateInternalStatus(
            e.status,
            candidateStatusValues,
          );
        }
        e["id"] = i + 1;
        if (
          e.sourcedFrom === "Cloudsourcing" ||
          e.sourcedFrom === "Employee Portal"
        ) {
          e["screeningquestions"] = `${e.anscount}/${e.qnscount}`;
        } else {
          e["screeningquestions"] = "";
        }
        newArray.push(e);
      });
      setAccociatedJobSeekerList(newArray);
      dispatch(_ser.getApplicantJobsStartReducer(initalState));
    } else if (GetApplicantJobsData?.length === 0) {
      setAccociatedJobSeekerList([]);
    }
  }, [GetApplicantJobsData, candidateStatusValues]);

  useEffect(() => {
    if (notesResponse !== null) {
      let data = JSON.parse(JSON.stringify(notesResponse));
      setNotesData(data);
    }
  }, [notesResponse]);

  useEffect(() => {
    if (AuditlogResponse && AuditlogResponse.length > 0) {
      let auditlog = JSON.parse(JSON.stringify(AuditlogResponse));
      auditlog.forEach((item) => {
        item.createdAt = GetTimeZone(item.createdAt);
      });
      setAuditlogData(auditlog);
      dispatch(_ser.getApplicantsCommentsStartReducer(initalState));
    }
  }, [AuditlogResponse]);

  useEffect(() => {
    if (ApplicantData && ApplicantData.length > 0) {
      let myData = JSON.parse(JSON.stringify(ApplicantData));
      let educationDetails = [],
        workExperience = [],
        finalCustomFieldsData = [];
      let newObj = {
        Applicants: {
          firstName: myData[0].firstName,
          lastName: myData[0].lastName,
          contactNumber: myData[0].contactNumber,
          alternateContactNumber: myData[0].alternateContactNumber,
          emailId: myData[0].emailId,
          location:
            myData[0]?.formattedLocation ?? myData[0]?.locationRawInput ?? "",
          resumesourceId: myData[0]?.resumesourceId,
          candidateStatus: myData[0].candidateStatus,
        },
        id: myData[0].id,
        applicantName: myData[0].firstName + " " + myData[0].lastName,
        firstName: myData[0].firstName,
        lastName: myData[0].lastName,
        emailId: myData[0].emailId,
        linkedIn: myData[0].linkedIn,
        contactNumber: myData[0].contactNumber,
        alternateContactNumber: myData[0].alternateContactNumber,
        source: myData[0].source,
        resumesource: myData[0].resumesource,
        totalExperience:
          myData[0].totalExperience || myData[0].yearsofExperience,
        skillDetails: myData[0].skillDetails
          ? safeJsonParse(myData[0].skillDetails)
          : [],
        certification:
          myData[0].certification && myData[0].certification !== "undefined"
            ? safeJsonParse(JSON.parse(myData[0].certification))
            : [],
        candidateStatus: myData[0].candidateStatus,
        applicantCode: myData[0].applicantCode,
        customFields: myData[0].customFields,
        rawData: myData[0].rawData,
        formattedLocation: myData[0]?.formattedLocation?.trim(),
        formattedLocationfromaddress:
          [myData[0]?.locationCity, myData[0]?.locationState, myData[0]?.locationCountry]
            .filter(Boolean).join(", "),
        locationRawInput: myData[0]?.locationRawInput ?? "",
        locationCity: myData[0]?.locationCity ?? "",
        locationState: myData[0]?.locationState ?? "",
        locationCountry: myData[0]?.locationCountry ?? "",
        latitude: myData[0]?.latitude ?? "",
        longitude: myData[0]?.longitude ?? "",
      };
      let educationObj = safeJsonParse(myData[0].educationDetails);
      let filterEducationData =
        educationObj?.filter(
          (x) =>
            (x.education || "").trim() !== "" || (x.degree || "").trim() !== "",
        ) || [];
      if (filterEducationData.length > 0) {
        filterEducationData.forEach((item, i) => {
          let newObj = {
            ...item,
            id: i,
            isEdit: item.isEdit ?? false,
            title: item?.degree || item?.education,
            degree: item?.degree || item?.education,
            organization: item?.organization,
            type: item?.locationFormated || item?.location?.formatted,
            workingOn:
              item?.startDate || item?.endDate
                ? `${item?.startDate ? formatDate(item?.startDate) : ""} ${item?.endDate ? " - " + formatDate(item?.endDate) : ""}`
                : "",
          };
          educationDetails.push(newObj);
        });
      }
      let workExpObj = safeJsonParse(myData[0].workExp);
      let filterWorkData =
        workExpObj?.filter((x) => (x.jobTitle || "").trim() !== "") || [];
      if (filterWorkData.length > 0) {
        filterWorkData.forEach((item, i) => {
          let newObj = { ...item };
          if (newObj.experienceInMonths === undefined) {
            newObj["experienceInMonths"] = getWorkonDate(item, "level1");
          }
          newObj.id = i;
          newObj.title = newObj?.jobTitle;
          newObj.isEdit = newObj.isEdit ?? false;
          newObj.organization = newObj?.organization;
          newObj.type = newObj?.empType;
          newObj.workingOn = getWorkonDate(
            newObj?.experienceInMonths,
            "level2",
          );
          workExperience.push(newObj);
        });
        const work = formatCurrentWorkExp(filterWorkData);
        if (work) {
          newObj["company"] = work.company;
          newObj["companyPeriod"] = work.companyPeriod;
          newObj["role"] = work.role;
        }
      }
      let customFields = myData[0].customFields
        ? safeJsonParse(JSON.parse(myData[0]?.customFields))
        : [];
      if (customFields !== null && customFields.length > 0) {
        let existingValues = [];
        if (customFieldsData && customFieldsData.length > 0) {
          const data = JSON.parse(JSON.stringify(customFieldsData));
          let customPostingFieldsData = data.filter(
            (x) => x.moduleId.toString() === "2" && x.fieldType === "custom",
          );
          existingValues = customPostingFieldsData.map((x) => {
            return x.fieldName;
          });
          console.log(existingValues);
        }
        customFields.forEach((item, i) => {
          if (
            item.value &&
            item.value?.toString()?.length > 0 &&
            existingValues.includes(item.key)
          ) {
            let newObj = {
              ...item,
              key: item.key,
              value: item.value.toString(),
            };
            finalCustomFieldsData.push(newObj);
          }
        });
      }
      let designation =
        workExperience?.length > 0
          ? `${workExperience[0]?.title || ""}${workExperience[0]?.organization ? " / " + workExperience[0]?.organization : ""}`
          : "";
      newObj["customFieldsArray"] = finalCustomFieldsData;
      newObj.educationDetails = educationDetails;
      newObj.workExp = workExperience;
      newObj.currentWorking = {
        designation: designation,
        from: workExperience[0]?.workingOn,
      };
      setApplicantsDetails(newObj);
      if (myData[0].firstName) {
        let additionalData = {
          applicantName:
            newObj.Applicants.firstName + " " + newObj.Applicants.lastName,
          currentWorking: newObj.currentWorking,
          emailId: newObj.Applicants.emailId,
          contactNumber: newObj.Applicants.contactNumber,
          alternateContactNumber: newObj.Applicants.alternateContactNumber,
          linkedIn: myData[0]?.linkedIn ?? "",
          location:
            newObj.Applicants.location ||
            myData[0]?.formattedLocation?.trim() ||
            [myData[0]?.locationCity, myData[0]?.locationState, myData[0]?.locationCountry]
              .filter(Boolean).join(", "),
        };
        setBreadCrumb(
          myData[0].id,
          myData[0]?.fullName ? myData[0]?.fullName : newObj.applicantName,
          "Applicant Code",
          additionalData,
        );
      }
      dispatch(_ser.applicantsByIdStartReducer(initalState));
    }
  }, [ApplicantData, customFieldsData]);

  // const sendEmail = useSelector((state) => state.SendEmail.data);

  /** Inline, file-local actions bar (no separate file needed) — JS version */
  function ApplicantInlineActions({ actions, hideClose = false, size = 36 }) {
    const [open, setOpen] = useState(false);

    const ActionItem = ({ icon, label, onClick }) => (
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
        <Tooltip title={label} arrow>
          <span onClick={onClick} aria-label={label}>
            {icon}
          </span>
        </Tooltip>
      </Box>
    );

    if (!open) {
      return (
        <Tooltip
          title="View More Options"
          arrow
          disableHoverListener={showEditApplicantDetails}
        >
          <span
            style={{
              cursor: showEditApplicantDetails ? "not-allowed" : "pointer",
              opacity: showEditApplicantDetails ? 0.5 : 1,
              pointerEvents: showEditApplicantDetails ? "none" : "auto",
            }}
            onClick={() => {
              if (!showEditApplicantDetails) {
                setOpen(true);
              }
            }}
          >
            <OptionsIcon />
          </span>
        </Tooltip>
      );
    }

    return (
      <Fade in={open}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          wrap="nowrap"
          sx={{ mx: 0, width: "auto" }}
        >
          {actions.map((a, idx) => (
            <Grid item key={idx}>
              <ActionItem icon={a.icon} label={a.label} onClick={a.onClick} />
            </Grid>
          ))}
          {!hideClose && (
            <Grid item>
              <ActionItem
                icon={<ApplicantCrossIcon />}
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Grid>
          )}
        </Grid>
      </Fade>
    );
  }

  const onCloseHandler = () => {
    setSavedApplicant(null);
    onReceiveProps("close-details");
    setShowEditApplicantDetails(false);
    setOverrideApplicantsDetails(null);
    dispatch(resetSelectedApplicant());
  };

  return (
    <Box
      sx={{ width: "100%", bgcolor: "#fff", borderRadius: 2 }}
      id="applicant-new"
    >
      {/* ========== MOBILE PROFILE VIEW ========== */}
      {isMobile ? (
        <Box className="mobile-profile-view" sx={{ px: 2, pb: 2 }}>
          {/* Back arrow */}
          <Box
            onClick={onCloseHandler}
            sx={{
              pt: 1.5,
              pb: 1,
              cursor: "pointer",
              display: "inline-flex",
            }}
          >
            <ChevronLeftIcon sx={{ fontSize: 24, color: "#555" }} />
          </Box>

          {/* Avatar */}
          <Box sx={{ width: 65, height: 65, mb: 1 }}>
            <ApplicantsIcon
              primaryColor={storedTheme?.primaryColor}
              primaryFontColor={storedTheme?.primaryFontColor}
            />
          </Box>

          {/* Name & subtitle */}
          <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.3 }}>
            {applicantsDetails?.firstName} {applicantsDetails?.lastName}
          </Typography>
          {(applicantsDetails?.company || applicantsDetails?.companyPeriod) && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.3 }}>
              {applicantsDetails?.company} {applicantsDetails?.companyPeriod}
            </Typography>
          )}

          {/* Contact info */}
          <Box
            sx={{ mt: 1.5, display: "flex", flexDirection: "column", gap: 0.8 }}
          >
            {applicantsDetails?.emailId && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon sx={{ fontSize: 18, color: "#333" }} />
                <a
                  href={"mailto:" + applicantsDetails?.emailId}
                  style={{ color: "#000", fontSize: 14 }}
                >
                  {applicantsDetails?.emailId}
                </a>
              </Box>
            )}
            {applicantsDetails?.contactNumber && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 18, color: "#333" }} />
                <span style={{ fontSize: 14 }}>
                  {applicantsDetails?.contactNumber}
                </span>
              </Box>
            )}
            {applicantsDetails?.alternateContactNumber && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 18, color: "#333" }} />
                <span style={{ fontSize: 14 }}>
                  {applicantsDetails?.alternateContactNumber}
                </span>
              </Box>
            )}
            {applicantsDetails?.formattedLocation && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AddressIcon style={{ flexShrink: 0, marginTop: "2px" }} />
                <span style={{ fontSize: 14 }}>
                  {applicantsDetails?.formattedLocation}
                </span>
              </Box>
            )}
            {applicantsDetails?.linkedIn && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LinkedInIcon sx={{ fontSize: 18, color: "#333" }} />
                <a
                  target="_blank"
                  href={getLinkedInPath(applicantsDetails?.linkedIn)}
                  style={{ color: "#000", fontSize: 14 }}
                >
                  Linkedin
                </a>
              </Box>
            )}
          </Box>

          {/* Overview content directly - no tabs */}
          <Box sx={{ mt: 2 }}>
            <ApplicantsDetailsOverview
              selectedApplicant={savedApplicant}
              applicantDetails={applicantsDetails}
              docUrl={previewType}
              documentId={document[0]?.id}
              docName={DocName}
              onPropsReceive={(type) => {
                onRenderComponentHandler(type);
              }}
            />
          </Box>
        </Box>
      ) : (
        <>
          {/* ========== DESKTOP VIEW (unchanged) ========== */}
          {/* Header */}
          <Box
            className="applicant-detail-header"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2, }}>
              <ApplicantsIcon
                primaryColor={storedTheme?.primaryColor}
                primaryFontColor={storedTheme?.primaryFontColor}
              />
              <Box style={{ maxWidth: '68%' }}>
                <Typography variant="h5" fontWeight={600}>
                  {applicantsDetails?.firstName &&
                    `${applicantsDetails?.firstName}`}{" "}
                  {applicantsDetails?.lastName &&
                    `${applicantsDetails?.lastName}`}
                </Typography>

                <Typography variant="p">
                  {applicantsDetails?.company}{" "}
                  {applicantsDetails?.companyPeriod}
                </Typography>

                {applicantsDetails?.emailId && (
                  <div className="actionLinks">
                    <span>
                      <EmailIcon
                        primaryFontColor={storedTheme?.secondaryColor}
                      />
                      <a href={"mailto:" + applicantsDetails?.emailId}>
                        {applicantsDetails?.emailId}
                      </a>
                    </span>
                  </div>
                )}
                <div className="actionLinks">
                  {applicantsDetails?.contactNumber && (
                    <span
                      style={{
                        alignItems: applicantsDetails?.alternateContactNumber
                          ? ""
                          : "flex-end",
                      }}
                    >
                      <PhoneIcon
                        primaryFontColor={storedTheme?.secondaryColor}
                      />{" "}
                      {applicantsDetails?.contactNumber} <br />
                      {applicantsDetails?.alternateContactNumber
                        ? `${applicantsDetails?.alternateContactNumber}`
                        : ""}
                    </span>
                  )}
                  {applicantsDetails?.linkedIn && (
                    <span>
                      <LinkedInIcon
                        primaryFontColor={storedTheme?.secondaryColor}
                      />{" "}
                      <a
                        target="_blank"
                        href={getLinkedInPath(applicantsDetails?.linkedIn)}
                      >
                        LinkedIn
                      </a>
                    </span>
                  )}
                  {(applicantsDetails?.formattedLocation || applicantsDetails?.formattedLocationfromaddress) && (
                    <span style={{ alignItems: "center" }}>
                      <AddressIcon style={{ flexShrink: 0, marginTop: "2px" }} />
                      {applicantsDetails?.formattedLocation || applicantsDetails?.formattedLocationfromaddress}{" "}
                    </span>
                  )}
                </div>
              </Box>
            </Box>

            {/* Actions */}
            <Box style={{ marginTop: '-25px' }}>
              <IconButton
                style={{
                  cursor: showEditApplicantDetails ? "not-allowed" : "pointer",
                  opacity: showEditApplicantDetails ? 0.5 : 1,
                  pointerEvents: showEditApplicantDetails ? "none" : "auto",
                  marginTop: "-20px",
                  position: "relative",
                  // right: "0px",
                }}
                onClick={() => {
                  if (!showEditApplicantDetails) {
                    onCloseHandler();
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
              {/* <div
                className="applicant-view-header"
                style={{
                  right: "108px",
                  marginTop: "-45px",
                  marginBottom: 0,
                  position: "absolute",
                }}
              >
                <ApplicantInlineActions actions={contactMenuOptions} />
              </div> */}
              <div
                className="applicant-view-header"
                style={{
                  right: "50px",
                  marginTop: "20px",
                  marginBottom: 0,
                  position: "absolute",
                }}
              >
                <FloatingMenu
                  config={{
                    inlineOptions: contactMenuOptions.filter((opt) =>
                      opt.action === "WhatsApp"
                        ? hasAnyPhoneNumber(applicantsDetails?.contactNumber)
                        : true,
                    ),
                  }}
                  floatingMenuOptions={ApplicantsDetailsTabsfloatingMenuOptions}
                  onReceiveActionHandler={onNavigateHandler}
                  storedTheme={storedTheme}
                />
              </div>
            </Box>
          </Box>

          <Divider />

          {/* Tabs */}
          {!Boolean(showEditApplicantDetails) && (
            <TabContext value={tab}>
              <Box>
                <TabList
                  id="Applicant-tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  onChange={(_, newValue) => {
                    onRenderComponentHandler("changeAppliant", newValue);
                    setTab(newValue);
                  }}
                  sx={{
                    mt: 1,
                    px: 2,
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: 500,
                    },
                    "& .Mui-selected": {
                      bgcolor: storedTheme.primaryColor,
                      borderRadius: 5,
                      color: "#000 !important",
                    },
                  }}
                >
                  <Tab value="overview" label="Overview" />
                  <Tab
                    value="associatejob"
                    label={`Associated Jobs (${accociatedJobSeekerList.length})`}
                  />
                  <Tab
                    value="document"
                    label={`Documents (${document.length})`}
                  />
                  <Tab value="notes" label={`Notes (${notesData.length})`} />
                  <Tab value="auditinfo" label="Audit Info" />
                </TabList>
              </Box>
              <TabPanel value="overview">
                <ApplicantsDetailsOverview
                  selectedApplicant={savedApplicant}
                  applicantDetails={applicantsDetails}
                  docUrl={previewType}
                  documentId={document[0]?.id}
                  docName={DocName}
                  onPropsReceive={(type) => {
                    onRenderComponentHandler(type);
                  }}
                />
              </TabPanel>
              <TabPanel value="associatejob">
                <div className="custom-dyanamic-table associateSection">
                  <ApplicantDetailsAssociatedJobs
                    data={accociatedJobSeekerList}
                    selectedAppliant={savedApplicant}
                    onReceiveProps={(type) => {
                      onRenderComponentHandler(type);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="document">
                <div className="custom-dyanamic-table document-section">
                  <ApplicantDetailsDocuments
                    data={document}
                    selectedAppliant={savedApplicant}
                    onReceiveProps={(type, object) => {
                      onRenderComponentHandler(type, object);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="notes">
                <div className="custom-dyanamic-table">
                  <ApplicantDetailsNotes
                    data={notesData}
                    selectedAppliant={savedApplicant}
                    onReceiveProps={(type) => {
                      onRenderComponentHandler(type);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value="auditinfo">
                <div className="custom-dyanamic-table">
                  <ApplicantDetailsAuditlogging data={auditlogData} />
                </div>
              </TabPanel>
            </TabContext>
          )}
          {Boolean(showEditApplicantDetails) && (
            <ApplicantDetailsEdit
              data={applicantsDetails}
              overridestate={overrideApplicantsDetails}
              onReceiveProps={(type, state) => {
                onRenderComponentHandler(type, state);
              }}
            />
          )}
          {Boolean(isContactApplicant) && (
            <ApplicantOtherActions
              tabvalue={tabvalue}
              applicantDetails={applicantsDetails}
              onReceivePropsHandler={onReceivePropsHandler}
              selectedOption={selectedOption}
            />
          )}
        </>
      )}
      <EmailDeliverySummary candidateMailId={applicantsDetails?.emailId} />
    </Box>
  );
};

export default ApplicantsDetailsTabs;
